<template>
  <div class="notification">
    <custom-table
      has-organization="true"
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      
      style="height: 95%"
      addText="创建平台通知"
      @addFn="handleAddNotification"
    >
      <template v-slot="scope">
        <span v-if="scope.item.prop === 'created'">{{ scope.row[scope.item.prop] | filterTime('YYYY-MM-DD HH:mm:SS') }}</span>
        <span v-else>{{ scope.row[scope.item.prop] || '-' }}</span>
      </template>
      <template #table-operation>
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button
              type="text"
              @click="handleAddNotification(row)"
            >查看</el-button>
          </div>
        </el-table-column>
      </template>
    </custom-table>
    <el-dialog
      width="750px"
      :visible.sync="isShowDialog"
      :title="editable ? '通知详情' : '创建平台通知'"
      :close-on-click-modal="false"
      @closed="onFormDialogClosed"
    >
      <el-form ref="form" class="form" :model="form" :rules="rules" :disabled="editable" v-loading="loadingDetail">
        <el-form-item label="通知标题" prop="title">
          <el-input v-model="form.title" placeholder="智慧云行用户协议" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="通知内容" prop="content" label-position="top">
          <wangEditor ref="editor"></wangEditor>
        </el-form-item>
        <el-form-item class="organize" v-if="!editable || form.sendOrganizationIds[0]">
          <template #label>
            <div>
              <span>群发机构</span>
              <span class="ml-15 color-999">机构下的司机都能收到通知</span>
              <span class="loading-organize" v-loading="oList.length === 0"></span>
            </div>
          </template>
          <p v-if="editable">{{ form.sendOrganizationIds[0] }}</p>
          <el-checkbox-group v-model="form.sendOrganizationIds" v-else>
            <el-checkbox
              v-for="(item, idx) in oList"
              :key="idx"
              :label="item.id"
            >{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="contact" v-if="!editable || form.sendDriverIds[0]">
          <template #label>
            <div>
              <span>群发司机</span>
              <span class="ml-15 color-999">可单独添加司机进行群发</span>
            </div>
          </template>
          <p v-if="editable">{{ form.sendDriverIds[0] }}</p>
          <template v-else>
            <transition-group tag="div" name="flip-list" class="contact-list" v-if="form.checkedDrivers.length">
              <el-button
                type="primary"
                size="mini"
                v-for="(item, idx) in form.checkedDrivers"
                :key="item.id"
                @click="form.checkedDrivers.splice(idx, 1)"
              >{{ item.name }}<i class="el-icon-error"></i></el-button>
            </transition-group>
            <span class="add" @click="handleShowAddDialog"><i class="el-icon-circle-plus"></i>添加司机</span>
          </template>
        </el-form-item>
        <el-button v-if="!editable" class="submit" type="primary" @click="handleConfirm" :loading="sending">{{ sending ? '正在发送...' : '立即发送' }}</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
      class="add-dialog"
      :visible.sync="isShowAddDialog"
      width="320px"
      title="添加司机"
      :close-on-click-modal="false"
      :before-close="onBeforeClose"
      @closed="onAddDialogClosed"
    >
      <div class="search">
        <span>搜索司机</span>
        <el-select
          v-model="drivers"
          remote
          filterable
          reserve-keyword
          :remote-method="remoteDrivers"
          :loading="getDriverLoading"
          value-key="id"
          multiple placeholder="请输入手机号码、姓名搜索"
          popper-class="driver-select"
        >
          <el-option
            v-for="item in options"
            :key="item.value.id"
            :value="item.value"
            :label="item.name"
            style="display: flex; justify-content: space-between;"
          >
            <span style="max-width: 70px; overflow: hidden; text-overflow: ellipsis;">{{ item.name }}</span>
            <span>{{ item.phone }}</span>
          </el-option>
        </el-select>
      </div>
      <el-button class="add-btn" type="primary" @click="handleAddDrivers">确认添加</el-button>
    </el-dialog>
  </div>
</template>

<script>
import wangEditor from "@/components/wangEditor";

export default {
  name: 'Notification',
  components: { wangEditor },
  data() {
    return {
      oList: [],
      sending: false,
      drivers: [],
      form: {
        title: '',
        content: '',
        sendOrganizationIds: [],
        sendDriverIds: [],
        checkedDrivers: []
      },
      rules: {
        title: [{ required: true, message: '请输入通知标题' }],
        content: [{ required: true, message: '请输入通知内容', trigger: 'change' }]
      },
      isShowDialog: false,
      isShowAddDialog: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/notification",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "title", name: "通知标题", value: "" },
          { type: "datetime", field: "time", name: "群发时间", value: [] },
        ],
      },
      columns: [
        { prop: "title", label: "通知标题", width: 320 },
        { prop: "contentBrief", label: "通知内容" },
        { prop: "created", label: "群发时间", width: 200 },
        { prop: "operator", label: "创建人", width: 200 },
      ],
      options: [],
      editable: false,
      loadingDetail: false,
      getDriverLoading: false,
      cuurentTextLength: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.getOrganizedList()
    },
    async getOrganizedList() {
      const url = '/api/v1/manage/organization/queryByAdminId'
      const res = await this.$axios.get(url)
      this.oList = res.data
    },
    async remoteDrivers(query) {
      if (query.trim() === '') {
        this.options = []
        return
      }
      this.getDriverLoading = true
      const url = '/api/v1/manage/notification/driver'
      const res = await this.$axios.get(url, {
        nameOrPhone: query.trim()
      })
      if (res.code === 1) {
        this.options = res.data.map(item => ({
          value: { id: item.id, name: item.name, phone: item.phone },
          name: item.name,
          phone: item.phone
        }))
      }
      this.getDriverLoading = false
    },
    handleAddDrivers() {
      this.form.checkedDrivers = JSON.parse(JSON.stringify(this.drivers))
      this.isShowAddDialog = false
    },
    handleShowAddDialog() {
      this.drivers = JSON.parse(JSON.stringify(this.form.checkedDrivers))
      this.options = this.drivers.map(item => ({
        value: { id: item.id, name: item.name, phone: item.phone },
        name: item.name,
        phone: item.phone
      }))
      this.isShowAddDialog = true
    },
    onBeforeClose(done) {
      if (Math.abs(this.drivers.length - this.form.checkedDrivers.length) >= 5) {
        this.$confirm('退出后编辑的司机无法保存，是否退出？', '提醒').then(() => done()).catch(() => {})
      } else {
        done()
      }
    },
    async handleConfirm() {
      const wangEditor = this.$refs.editor
      const txt = wangEditor.editor.txt
      const html = txt.html()
      if (this.form.title.trim() === '') {
        this.$message.warning({ message: '请输入通知标题' })
        return
      }
      if (html.trim() === '') {
        this.$message.warning({ message: '请输入通知内容' })
        return
      }
      if (this.form.checkedDrivers.length === 0 && this.form.sendOrganizationIds.length === 0) {
        this.$message.warning({ message: '请添加要群发的机构或司机' })
        return
      }
      const text = txt.text()
      const form = {
        title: this.form.title,
        content: html,
        contentBrief: text.substring(0, 100),
        sendDriverIds: this.form.checkedDrivers.map(item => item.id).join(','),
        sendOrganizationIds: this.form.sendOrganizationIds.join(','),
      }
      const confirm = await this.$confirm('确认发送通知吗？', '提醒').catch(() => {})
      if (confirm) {
        const url = '/api/v1/manage/notification'
        this.sending = true
        const res = await this.$axios.post(url, form)
        this.sending = false
        if (res.code === 1) {
          this.$message.success({ message: '通知发送成功' })
          this.isShowDialog = false
          this.$refs.customTable.listFn()
        }
      }
    },
    onFormDialogClosed() {
      this.$refs.editor.clear()
      this.options = []
      this.form = {
        title: '',
        content: '',
        sendOrganizationIds: [],
        sendDriverIds: [],
        checkedDrivers: []
      }
      this.$refs.form.resetFields()
    },
    onAddDialogClosed() {
      this.options = []
      this.drivers = []
    },
    handleAddNotification(row) {
      this.editable = false
      this.isShowDialog = true
      
      if (row) {
        this.editable = true
        this.$nextTick(async () => {
          const wangEditor = this.$refs.editor
          wangEditor.editor.disable()
          const url = `/api/v1/manage/notification/${row.id}`
          this.loadingDetail = true
          const res = await this.$axios.get(url)
          this.loadingDetail = false
          if (res.code === 1) {
            this.form.title = res.data.title
            wangEditor.setHtml(res.data.content)
            this.form.sendDriverIds.push(res.data.sendDriver)
            this.form.sendOrganizationIds.push(res.data.sendOrganization)
          }
        })
      } else {
        this.$nextTick(() => {
          const editor = this.$refs.editor.editor
          this.editor = editor
          editor.enable()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  & /deep/ .el-form-item {
    &:first-child {
      display: flex;
      align-items: center;
      .el-form-item__content {
        flex: 1;
        margin-top: 0;
      }
    }

    .el-form-item__content {
      margin-top: 30px;
    }
    &.organize {
      .el-form-item__content {
        .el-checkbox {
          width: 25%;
          margin-right: 0;
          padding-right: 10px;
          box-sizing: border-box;
          &__label {
            white-space: normal;
            vertical-align: middle;
          }
        }
      }
    }
    &.contact {
      .contact-list {
        margin-top: 7px;
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
      }
      .el-button {
        position: relative;
        margin-left: 0;
        margin-right: 15px;
        margin-bottom: 10px;
        i {
          font-size: 16px;
          color: #000;
          position: absolute;
          bottom: 16px;
          right: -6px;
        }
      }
      .add {
        i {
          margin-right: 5px;
        }
        color: rgb(73, 146, 255);
        cursor: pointer;
        display: inline-block;
      }
    }
  }
  & /deep/ .submit {
    width: 350px;
    height: 35px;
    margin: 10px auto 0 auto;
    display: block;
  }
}

.add-dialog {
  .add-btn {
    width: 100%;
    height: 35px;
    margin-top: 20px;
  }
  & /deep/ .el-dialog__header {
    padding: 20px !important;
  }
  & /deep/ .el-dialog__body {
    padding: 0 20px 20px 20px !important;
    .search {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .el-select {
        flex: 1;
        .el-select__tags {
          max-width: 90% !important;
        }
        .el-input__inner {
          padding-right: 15px;
        }
        .el-input__suffix {
          display: none;
        }
      }
      & > span {
        min-width: 70px;
      }
    }
  }
}
.loading-organize {
  /deep/ .el-loading-spinner {
    margin-top: -14px;
    left: 10px;
  }
  /deep/ .circular {
    width: 26px;
    height: 26px;
  }
}
.text-limit {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  span:nth-child(2) {
    margin: 0 2px;
    transform: translateY(-1px);
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 5px;
}
.el-select-dropdown {
  transform: translateX(100%) !important;
}
.ml-15 { margin-left: 15px; }
.color-999 { color: #999; }
.flip-list-enter, .flip-list-leave-to {
  opacity: 0 !important;
}
.flip-list-enter-active, .flip-list-leave-active {
  opacity: 1;
  transition: all .5s;
}
.flip-list-leave-active {
  position: absolute !important;
}
.flip-list-move {
  transition: transform .5s;
}
</style>